











































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import { DocumentSummary } from "../../../domain/document";
import { Patient } from "../../../domain/patient";
import {
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
  IOptionFilterable
} from "../../system";
import { DocumentListViewer } from "../viewers";
import { IDocumentSelectCondition } from "./IDocumentSelectCondition";
import { DocumentListViewMixin } from "../mixins";

@Component({
  components: {
    DocumentListViewer,
  }
})
export default class DocumentSelectDialog extends Mixins(DialogMixin, DocumentListViewMixin) implements ISingleSelectableAsynchronously<DocumentSummary>, ISingleSelectableConditionallyAsynchronously<DocumentSummary, IDocumentSelectCondition>, IOptionFilterable<DocumentSummary> {
  $refs!: {
    viewer: DocumentListViewer;
  };

  data(): any {
    return {
      name: null,
      patient: null,
      isSelected: false,
      selectingDocument: null as DocumentSummary,
      isShownFirst: true,
      ignoreDocumentId: null,
      editingDocumentName: "",
      isOtherPatientSelectable: false,
    };
  }
  name: string;
  patient: Patient;
  isSelected: boolean;
  selectingDocument: DocumentSummary;
  isShownFirst: boolean;
  ignoreDocumentId: number;
  editingDocumentName: string;
  isOtherPatientSelectable: boolean;

  public filteredOptions: DocumentSummary[] = null;
  public filteredText: string = "";

  get isDocumentSelecting(): boolean {
    return (this.selectingDocument !== null);
  }

  async selectOption(defaultOption?: DocumentSummary): Promise<DocumentSummary> {
    return this.selectOptionConditionally({}, defaultOption);
  }

  async selectOptionConditionally(condition: IDocumentSelectCondition, defaultOption?: DocumentSummary): Promise<DocumentSummary> {
    this.name = (condition && condition.name) ? condition.name : "文書選択";
    this.patient = (condition && condition.patient) ? condition.patient : null;
    this.ignoreDocumentId = (condition && condition.ignoreDocumentId) ? condition.ignoreDocumentId : null;
    this.editingDocumentName = (condition && condition.editingDocumentName) ? condition.editingDocumentName : "";
    this.isOtherPatientSelectable = (condition && condition.isOtherPatientSelectable);

    return this.showModal(async () => {
      this.isSelected = false;
      await this.$nextTick();
      if (this.isShownFirst && this.$refs.viewer) {
        this.$refs.viewer.clear(); // patientを渡した際、DocumentsFinderのWatchが反応しないため明示的に呼ぶようにした
        this.isShownFirst = false;
      }
      if (this.$refs.viewer) {
        this.$refs.viewer.resetInfiniteLoading();  // 検索中にダイアログが閉じられ再び開いた際、読み込みが行われなくなるため
      }
      await this.waitHidden();
      return this.isSelected
        ? this.selectingDocument
        : undefined;
    });
  }

  selectDocument(): void {
    this.isSelected = true;
    this.isVisible = false;
    this.filteredOptions = this.$refs.viewer.filteredOptions;
    this.filteredText = this.$refs.viewer.filteredText;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
